import type { DocumentUploadFile } from "@ps-bridge/models/brands/documentUploadFile";
import {
  makeDocumentUploadFile,
  unwrap as unwrapDocumentUploadFile,
} from "@ps-bridge/models/brands/documentUploadFile";
import { ok } from "@ps-bridge/ok";
import type { Ok } from "@ps-bridge/ok";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";

const uploadFilesByName = new Map<string, File>();

export const registerDocumentUploadFile = (file: File): DocumentUploadFile => {
  const branded = makeDocumentUploadFile(file.name);
  const key = unwrapDocumentUploadFile(branded);
  uploadFilesByName.set(key, file);
  return branded;
};

export const registerDocumentUploadFiles = (
  files: FileList | File[],
): Array<DocumentUploadFile> => {
  const fileArray = Array.isArray(files) ? files : Array.from(files);
  return fileArray.map((file) => registerDocumentUploadFile(file));
};

export const peekDocumentUploadFile = (file: DocumentUploadFile): OptionTs<File> => {
  const entry = uploadFilesByName.get(unwrapDocumentUploadFile(file));
  return entry ? Option.some(entry) : Option.none();
};

export const removeDocumentUploadFile = (file: DocumentUploadFile): Ok => {
  uploadFilesByName.delete(unwrapDocumentUploadFile(file));
  return ok;
};
